"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _Tiles = _interopRequireDefault(require("../../components/Tiles"));
var _MessageCard = _interopRequireDefault(require("../../components/Cards/MessageCard"));
var _DropZoneModal = _interopRequireDefault(require("../../components/Modals/DropZoneModal"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var AccountHistory = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(AccountHistory, _PureComponent);
  function AccountHistory() {
    var _this;
    (0, _classCallCheck2["default"])(this, AccountHistory);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, AccountHistory, [].concat(args)), _this.state = {
      showCensusModal: false,
      showRateHistoryModal: false,
      showClaimsHistoryModal: false,
      showEmailsModal: false,
      showUploadModal: false,
      successDialogOpen: false,
      rateHistory: null,
      claimsHistory: null,
      pastBill: null,
      supportingDocs: []
    }, _this._toggleModal = function (type) {
      var currentState = _this.state[type];
      _this.setState((0, _defineProperty2["default"])({
        showCensusModal: false,
        showRateHistoryModal: false,
        showClaimsHistoryModal: false,
        showEmailsModal: false,
        showPastBillModal: false,
        showUploadModal: false
      }, type, !currentState));
    }, _this.collectFiles = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(files, type) {
        var fileType;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              fileType = null;
              _context.t0 = type;
              _context.next = _context.t0 === 'Census' ? 4 : _context.t0 === 'Rate History' ? 6 : _context.t0 === 'Claims History' ? 8 : _context.t0 === 'Past Bill' ? 10 : _context.t0 === 'Emails' ? 12 : 14;
              break;
            case 4:
              fileType = 'census';
              return _context.abrupt("break", 16);
            case 6:
              fileType = 'rateHistory';
              return _context.abrupt("break", 16);
            case 8:
              fileType = 'claimsHistory';
              return _context.abrupt("break", 16);
            case 10:
              fileType = 'pastBill';
              return _context.abrupt("break", 16);
            case 12:
              fileType = 'emails';
              return _context.abrupt("break", 16);
            case 14:
              fileType = 'supportingDocs';
              return _context.abrupt("break", 16);
            case 16:
              _context.next = 18;
              return _this.setState((0, _defineProperty2["default"])({}, fileType, files));
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(), _this._submitFile = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(files, type) {
        var form, success;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              form = new FormData();
              form.append('type', type);
              _context2.t0 = type;
              _context2.next = _context2.t0 === 'Census' ? 5 : _context2.t0 === 'Rate History' ? 7 : _context2.t0 === 'Claims History' ? 9 : _context2.t0 === 'Past Bill' ? 11 : _context2.t0 === 'Emails' ? 13 : 15;
              break;
            case 5:
              form.append('census', files[0]);
              return _context2.abrupt("break", 18);
            case 7:
              form.append('rateHistory', files[0]);
              return _context2.abrupt("break", 18);
            case 9:
              form.append('claimsHistory', files[0]);
              return _context2.abrupt("break", 18);
            case 11:
              form.append('pastBill', files[0]);
              return _context2.abrupt("break", 18);
            case 13:
              form.append('emails', files[0]);
              return _context2.abrupt("break", 18);
            case 15:
              form.append("supportingDocs", null);
              files.map(function (item) {
                form.append("supportingDocs", item);
                return true;
              });
              return _context2.abrupt("break", 18);
            case 18:
              _context2.next = 20;
              return _this.props.uploadAccountHistory(form, type, _this.props.accountID);
            case 20:
              success = _context2.sent;
              if (success) {
                _this.setState({
                  successDialogOpen: true
                });
              }
            case 22:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }(), (0, _assertThisInitialized2["default"])(_this)));
  }
  /**
   * Hide all current modals then set the desired modal to the correct state
   * @param type
   * @private
   */
  (0, _createClass2["default"])(AccountHistory, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var tiles = [{
        title: _i18n["default"].t(_tokens["default"].titles.census),
        description: _i18n["default"].t(_tokens["default"].labels.accountHistory.provideCensusDocument),
        onClick: function onClick() {
          return _this2._toggleModal('showCensusModal');
        }
      }, {
        title: _i18n["default"].t(_tokens["default"].labels.accountHistory.rateHistory),
        description: _i18n["default"].t(_tokens["default"].labels.accountHistory.enterRateHistory),
        onClick: function onClick() {
          return _this2._toggleModal('showRateHistoryModal');
        }
      }, {
        title: _i18n["default"].t(_tokens["default"].labels.accountHistory.claimsHistory),
        description: _i18n["default"].t(_tokens["default"].labels.accountHistory.enterClaimsHistory),
        onClick: function onClick() {
          return _this2._toggleModal('showClaimsHistoryModal');
        }
      }, {
        title: _i18n["default"].t(_tokens["default"].labels.accountHistory.pastBill),
        description: _i18n["default"].t(_tokens["default"].labels.accountHistory.pastBill),
        onClick: function onClick() {
          return _this2._toggleModal('showPastBillModal');
        }
      }, {
        title: _i18n["default"].t(_tokens["default"].labels.claims.supportingDocuments),
        description: _i18n["default"].t(_tokens["default"].labels.accountHistory.uploadSupportingDocuments),
        onClick: function onClick() {
          return _this2._toggleModal('showUploadModal');
        }
      }];
      if (this.props.isMasterSite) {
        tiles.push({
          title: _i18n["default"].t(_tokens["default"].labels.accountHistory.emails),
          description: _i18n["default"].t(_tokens["default"].labels.accountHistory.uploadEmailsReceived),
          onClick: function onClick() {
            return _this2._toggleModal('showEmailsModal');
          }
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].labels.accountHistory.submitAccountHistory),
        subtitle: _i18n["default"].t(_tokens["default"].labels.accountHistory.uploadCensusRateClaimsHistory),
        btn: this.props.isMasterSite && this.props.downloadAccountHistory,
        btnName: "Download Account History",
        btnOnClick: this.props.downloadAccountHistory
      }), /*#__PURE__*/_react["default"].createElement(_Tiles["default"], {
        tiles: tiles
      }), this.state.showCensusModal && /*#__PURE__*/_react["default"].createElement(_DropZoneModal["default"], {
        testid: "census-modal",
        title: _i18n["default"].t(_tokens["default"].labels.accountHistory.selectCensusDocument),
        hideModal: this._toggleModal,
        showModal: this.state.showCensusModal,
        maxItems: 1,
        type: "Census",
        collectFiles: this.collectFiles,
        submitFile: this._submitFile,
        acceptedFiles: "application/vnd.ms-excel, application/pdf, text/csv, .csv, .excel, .xls, .xlsx, .pdf, image/*, .png, .jpg, .jpeg",
        loading: this.props.loading,
        whitelabel: this.props.whitelabel
      }), this.state.showRateHistoryModal && /*#__PURE__*/_react["default"].createElement(_DropZoneModal["default"], {
        testid: "rate-history-modal",
        title: _i18n["default"].t(_tokens["default"].labels.accountHistory.selectRateHistoryDocument),
        hideModal: this._toggleModal,
        showModal: this.state.showRateHistoryModal,
        maxItems: 1,
        type: "Rate History",
        collectFiles: this.collectFiles,
        submitFile: this._submitFile,
        acceptedFiles: "application/vnd.ms-excel, application/pdf, text/csv, .csv, .excel, .xls, .xlsx, .pdf, image/*, .png, .jpg, .jpeg",
        loading: this.props.loading,
        whitelabel: this.props.whitelabel
      }), this.state.showClaimsHistoryModal && /*#__PURE__*/_react["default"].createElement(_DropZoneModal["default"], {
        testid: "claims-history-modal",
        title: _i18n["default"].t(_tokens["default"].labels.accountHistory.selectClaimsHistoryDocument),
        hideModal: this._toggleModal,
        showModal: this.state.showClaimsHistoryModal,
        maxItems: 1,
        type: "Claims History",
        collectFiles: this.collectFiles,
        submitFile: this._submitFile,
        acceptedFiles: "application/vnd.ms-excel, application/pdf, text/csv, .csv, .excel, .xls, .xlsx, .pdf, image/*, .png, .jpg, .jpeg",
        loading: this.props.loading,
        whitelabel: this.props.whitelabel
      }), this.state.showPastBillModal && /*#__PURE__*/_react["default"].createElement(_DropZoneModal["default"], {
        testid: "past-bill-modal",
        title: _i18n["default"].t(_tokens["default"].labels.accountHistory.selectPastBillDocument),
        hideModal: this._toggleModal,
        showModal: this.state.showPastBillModal,
        maxItems: 1,
        type: "Past Bill",
        collectFiles: this.collectFiles,
        submitFile: this._submitFile,
        acceptedFiles: "application/vnd.ms-excel, application/pdf, text/csv, .csv, .excel, .xls, .xlsx, .pdf, image/*, .png, .jpg, .jpeg",
        loading: this.props.loading,
        whitelabel: this.props.whitelabel
      }), this.state.showEmailsModal && /*#__PURE__*/_react["default"].createElement(_DropZoneModal["default"], {
        testid: "email-modal",
        title: _i18n["default"].t(_tokens["default"].labels.accountHistory.selectEmailDocument),
        hideModal: this._toggleModal,
        showModal: this.state.showEmailsModal,
        maxItems: 1,
        type: "Emails",
        collectFiles: this.collectFiles,
        submitFile: this._submitFile,
        acceptedFiles: "application/vnd.ms-excel, application/pdf, text/csv, .csv, .excel, .xls, .xlsx, .pdf, image/*, .png, .jpg, .jpeg",
        loading: this.props.loading,
        whitelabel: this.props.whitelabel
      }), this.state.showUploadModal && /*#__PURE__*/_react["default"].createElement(_DropZoneModal["default"], {
        testid: "supporting-documents-modal",
        title: _i18n["default"].t(_tokens["default"].labels.accountHistory.selectSupportingDocuments),
        hideModal: this._toggleModal,
        showModal: this.state.showUploadModal,
        maxItems: 2,
        type: "Supporting Documents",
        collectFiles: this.collectFiles,
        submitFile: this._submitFile,
        acceptedFiles: "application/vnd.ms-excel, application/pdf, text/csv, .csv, .excel, .xls, .xlsx, .pdf, image/*, .png, .jpg, .jpeg",
        loading: this.props.loading,
        whitelabel: this.props.whitelabel
      }), /*#__PURE__*/_react["default"].createElement("span", {
        id: "accountHistory"
      }));
    }
  }]);
  return AccountHistory;
}(_react.PureComponent);
var _default = exports["default"] = AccountHistory;